import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
import { useAlert } from '../context/AlertContext';

const AutoLogout = () => {
    const { user, logout } = useStore();
    const { showAlert } = useAlert();
    const location = useLocation();
    const timeoutRef = useRef(null);
    
    // 5분 = 5 * 60 * 1000 밀리초
    const INACTIVITY_LIMIT = 5 * 60 * 1000;

    const resetTimeout = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        
        // 유저가 로그인 된 상태일 때만 타이머 작동
        if (user) {
            timeoutRef.current = setTimeout(() => {
                logout();
                showAlert('5분 동안 활동이 없어 자동으로 로그아웃 되었습니다.');
            }, INACTIVITY_LIMIT);
        }
    };

    useEffect(() => {
        const events = ['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart', 'scroll', 'click'];
        
        const handleActivity = () => {
            resetTimeout();
        };

        if (user) {
            resetTimeout();
            // 활동 감지 이벤트 리스너 등록
            events.forEach(event => {
                window.addEventListener(event, handleActivity);
            });
        } else {
            // 로그아웃 상태면 타이머 해제
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            events.forEach(event => {
                window.removeEventListener(event, handleActivity);
            });
        };
    }, [user, logout, showAlert]);

    // 라우터 경로가 변경될 때도 사용자 활동으로 간주하여 타이머 초기화
    useEffect(() => {
        resetTimeout();
    }, [location.pathname]);

    // [신규] admin1 ~ admin3 선접속 유지용 하트비트 전송
    useEffect(() => {
        let heartbeatInterval;
        
        if (user && ['admin1', 'admin2', 'admin3', 'admin4'].includes(user.id)) {
            const sendHeartbeat = () => {
                const baseUrl = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
                    ? 'http://localhost:3001/api' 
                    : `${window.location.origin}/api`;
                    
                fetch(`${baseUrl}/heartbeat`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userId: user.id })
                }).catch(err => console.error('Heartbeat failed:', err));
            };

            // 처음 연결 시 즉시 한 번 전송
            sendHeartbeat();
            
            // 이후 1분마다 주기적 전송 (서버 만료 기준은 6분)
            heartbeatInterval = setInterval(sendHeartbeat, 60 * 1000);
        }

        return () => {
            if (heartbeatInterval) clearInterval(heartbeatInterval);
        };
    }, [user]);

    return null; // UI를 렌더링하지 않는 백그라운드 컴포넌트
};

export default AutoLogout;
